ft.app.controller('contractRejectModalController',
    ['$scope', '$element', 'close', 'item', '$timeout', '$translate', 'DataService', 'AppService',
        function ($scope, $element, close, item, $timeout, $translate, DataService, AppService) {

            var initialized = false;

            $scope.data = {
                item: item,
                reject: false,
                comments: '',
                saving: false,
                saveEnabled: true,
                attempts: 0,
                successMessage: '',
                errorMessage: ''
            };

            $scope.initialize = function () {

                var data = $scope.data;

                if (initialized) {
                    return;
                }

                initialized = true;

            };

            $scope.save = function () {
                var data = $scope.data;
                data.successMessage = '';
                data.errorMessage = '';

                if (!data.reject) {
                    return;
                }

                data.saving = true;
                var prm = DataService.rejectContractAsync(item.child, item.contract.id, data.comments);
                prm.then($scope.handleSave, $scope.handleSaveError);
                prm.finally(function () {
                    data.saving = false;
                });
            };

            $scope.handleSave = function (results) {
                $scope.data.saveEnabled = false;
                $scope.data.attempts = 0;
                $scope.data.successMessage = $translate.instant('CONTRACTS-REJECT.REJECTION-SAVED');
            };

            $scope.handleSaveError = function (response) {
                $scope.data.attempts += 1;

                if ($scope.data.attempts > 3) {
                    $scope.data.errorMessage = $translate.instant('CONTRACTS-REJECT.ERROR-CONTINUES');
                } else {
                    $scope.data.errorMessage = response && !response.result && response.isReadable ? response.message : $translate.instant('CONTRACTS-REJECT.ERROR-SAVE-REJECTION');
                }
            };

            $scope.cancel = function () {
                close();
            };

            $scope.close = function () {
                close({
                    success: !$scope.data.saveEnabled
                });
            };

            $timeout($scope.initialize);

        }
    ]);

